import React, { useEffect } from "react";
import { SpinnerWrapper } from "../../components/styles";
import Spinner from "../../../../utils/Spinner";
import { FibiUsersBillingData, FibiUsersBillingType } from "./data";
import FibiUsersBillingCard from "./FibiUsersBillingCard";
import { useFibiUsersSubscriptionPayment } from "../../../../hooks/utils/useUtils";
import useGetPrice from "../../../../hooks/useGetPrice";
import { toast } from "react-toastify";
import { userDataStore } from "../../../../store/userData";
import { useSnapshot } from "valtio";
import { PayStackParam } from "../../form ds 160/components/types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BillingStripeQuery } from "./business/billing/components/data";
import StripeSuccessModal from "./StripeSuccessModal";
import Button from "../../pages/For Business/components/Button";
import { WebPaths } from "../../../../routes/data";
import {
  FibiAiQuery,
  FibiAiQueryValue,
} from "../../pages/FiBi/voice/components/data";

const FibiUsers = () => {
  const navigate = useNavigate();
  const { userData } = useSnapshot(userDataStore);
  //   const { isBusinessData } = useSnapshot(isBusinessDataStore);
  //   const {
  //     data: businessUserData,
  //     isLoading: businessDataLoading,
  //     refetch,
  //   } = useGetBusinessProfile(isBusinessData);
  const { isNigeria } = useGetPrice();
  const [searchParams, setSearchParams] = useSearchParams();
  const { mutate: submutate, isLoading: subLoading } =
    useFibiUsersSubscriptionPayment();
  const billingTypeParams = searchParams.get(
    BillingStripeQuery.billingType
  ) as string;
  const paymentTypeParams =
    searchParams.get(BillingStripeQuery.paymentType) || "";
  //   const { mutate: upgradeMutate, isLoading: upgradeLoading } =
  //     useBusinessBillingUpgrade();
  //   const { mutate: downgradeMutate, isLoading: downgradeLoading } =
  //     useBusinessBillingDowngrade();
  //   const [upgradeOpen, setUpgradeOpen] = useState<BillingType>();
  //   const [downgradeOpen, setDowngradeOpen] = useState<BillingType>();

  //   const onUpgradeOpen = (second: BillingType) => {
  //     setUpgradeOpen(second);
  //   };

  //   const onUpgradeClose = () => {
  //     setUpgradeOpen(undefined);
  //   };

  //   const onDowngradeOpen = (second: BillingType) => {
  //     setDowngradeOpen(second);
  //   };

  //   const onDowngradeClose = () => {
  //     setDowngradeOpen(undefined);
  //   };

  //   const onUpgrade = () => {
  //     if (!upgradeOpen) return;

  //     const payload = {
  //       isNigeria,
  //       billingType: upgradeOpen,
  //     };

  //     upgradeMutate(payload, {
  //       onSuccess: () => {
  //         onUpgradeClose();
  //         refetch();
  //         toast.success("Upgrade Successful");
  //       },
  //     });
  //   };

  //   const onDowngrade = () => {
  //     if (!downgradeOpen) return;
  //     const payload = { email: [], isNigeria, billingType: downgradeOpen };

  //     downgradeMutate(payload, {
  //       onSuccess: () => {
  //         onDowngradeClose();
  //         refetch();
  //         toast.success("Downgrade Successful");
  //       },
  //     });
  //   };

  const onSubmit = (params: FibiUsersBillingType) => {
    if (params === FibiUsersBillingType.full) {
      toast.info("Plan not available at the moment");

      return;
    }
    const payload = {
      billingType: params,
      isNigeria,
    };

    submutate(payload, {
      onSuccess: (data) => {
        window.location.replace(data.data.url);
      },
    });
  };

  const onClick = (params: FibiUsersBillingType) => {
    // const isYearly = (plan: BillingType) =>
    //   plan.toLowerCase().includes("yearly");

    // const checkGrade = () => {
    //   if (!businessUserData?.paymentInfo.subscriptionType) return;

    //   const currentPlan = businessUserData.paymentInfo.subscriptionType;
    //   const requestedPlan = params;

    //   const currentRank = PlanRank[currentPlan];
    //   const requestedRank = PlanRank[requestedPlan];

    //   // If any plan is not ranked, exit early
    //   if (!currentRank || !requestedRank) return;

    //   if (currentRank === requestedRank) {
    //     // Same plan level: check for monthly vs yearly differences.
    //     if (isYearly(currentPlan) && !isYearly(requestedPlan)) {
    //       // Downgrading from yearly to monthly
    //       onDowngradeOpen(requestedPlan);
    //     } else if (!isYearly(currentPlan) && isYearly(requestedPlan)) {
    //       // Upgrading from monthly to yearly
    //       onUpgradeOpen(requestedPlan);
    //     }
    //     // If both share the same period type, nothing to do.
    //     return;
    //   }

    //   // For different ranks, a higher rank is an upgrade.
    //   if (requestedRank > currentRank) {
    //     onUpgradeOpen(requestedPlan);
    //   } else {
    //     onDowngradeOpen(requestedPlan);
    //   }
    // };
    // businessUserData?.paymentInfo.subscriptionType
    //   ? checkGrade()
    //   : onSubmit(params);

    onSubmit(params);
  };

  //   const masterLoading = subLoading || businessDataLoading;
  const masterLoading = subLoading;

  useEffect(() => {
    const trxrefParam = searchParams.get(PayStackParam.trxref);
    const referenceParam = searchParams.get(PayStackParam.reference);

    if (trxrefParam) {
      searchParams.delete(PayStackParam.trxref);
    }

    if (referenceParam) {
      searchParams.delete(PayStackParam.reference);
    }
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  const onToFibiAI = () => {
    navigate(
      `${WebPaths.FiBiVoice}?${FibiAiQuery.userType}=${FibiAiQueryValue.fibiUser}`
    );
  };

  return (
    <>
      {/* <div className="flex flex-wrap items-center justify-between gap-6 mb-4">
        <Header>FiBi AI</Header>
      </div> */}

      <div className="flex flex-col gap-4 py-6 mb-10">
        <h5 className="text-xl font-medium text-primaryColor">FiBi AI</h5>

        <p className="">
          Meet FiBi AI - Your Personal Interview Trainer. Practice real U.S.
          visa interview questions with both text and voice simulations to boost
          your confidence and approval chances.
        </p>

        <div className="flex items-center justify-center w-[30%] mx-auto [&>button]:w-full">
          <Button
            text={`${
              userData?.fibiSubInfo
                ? "Start Your Practice Now"
                : "Try Now For Free"
            }`}
            type="button"
            onClick={onToFibiAI}
          />
        </div>
      </div>

      <div className="flex flex-col gap-4 p-6 border border-gray-100 rounded-xl">
        <h5 className="text-lg font-medium text-primaryColor">Select Plan</h5>

        {masterLoading ? (
          <SpinnerWrapper>
            <Spinner size={40} />
          </SpinnerWrapper>
        ) : (
          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 ">
            {FibiUsersBillingData.map((ev, index) => (
              <FibiUsersBillingCard
                key={index}
                data={ev}
                onButtonClick={onClick}
                currentPlan={userData?.fibiSubInfo?.subscriptionType || ""}
              />
            ))}
          </div>
        )}
      </div>

      {billingTypeParams && paymentTypeParams && <StripeSuccessModal />}
      {/* {downgradeOpen && (
        <TerminateModal
          title={`Downgrade Subscription`}
          subText={`Are you sure you want to downgrade your subscription?`}
          onClose={onDowngradeClose}
          onConfirm={onDowngrade}
          isLoading={downgradeLoading}
          confirmBg={Colors.Blue00}
        />
      )} */}

      {/* {upgradeOpen && (
        <TerminateModal
          title={`Upgrade Subscription`}
          subText={`Are you sure you want to upgrade your subscription?`}
          onClose={onUpgradeClose}
          onConfirm={onUpgrade}
          isLoading={upgradeLoading}
          confirmBg={Colors.Blue00}
        />
      )} */}
    </>
  );
};

export default FibiUsers;
